(function () {
  const CODE_PATTERN = /^[A-Za-z0-9._-]{3,}$/;

  let hasRun = false;

  function applyDiscount(code) {
    return fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, {
      credentials: 'same-origin'
    }).catch((e) => {
      console.error('GWP link: could not apply discount code', e);
    });
  }

  function addVariant(cartDrawer, variantId) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('GWP link: could not add variant', variantId, response.description);
          return null;
        }
        return response;
      })
      .catch((e) => {
        console.error('GWP link: could not add variant', variantId, e);
        return null;
      });
  }

  function fetchSections(cartDrawer) {
    const sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');

    return fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => response.json())
      .then((sections) => ({ sections: sections }))
      .catch((e) => {
        console.error('GWP link: could not refresh cart sections', e);
        return null;
      });
  }

  function cleanUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('gwp');
    url.searchParams.delete('variant_id');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  document.addEventListener('DOMContentLoaded', async () => {
    if (hasRun) return;

    const params = new URLSearchParams(window.location.search);
    const code = (params.get('gwp') || '').trim();
    if (!code) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    hasRun = true;

    if (CODE_PATTERN.test(code)) await applyDiscount(code);

    const variantId = (params.get('variant_id') || '').trim();
    let state = null;

    if (/^\d+$/.test(variantId)) state = await addVariant(cartDrawer, variantId);
    if (!state) state = await fetchSections(cartDrawer);

    if (state) {
      cartDrawer.renderContents(state);
      const renderedItems = cartDrawer.querySelector('cart-drawer-items');
      cartDrawer.classList.toggle('is-empty', !renderedItems || renderedItems.classList.contains('is-empty'));
    } else {
      cartDrawer.open();
    }

    cleanUrl();
  });
})();
